// Measures round-trip time to a Google endpoint to distinguish user-side
// network problems from server-side problems when our socket latency is high.

const GOOGLE_PROBE_URL = "https://www.google.com/favicon.ico";
const PROBE_TIMEOUT_MS = 5000;

export type ConnectivityResult =
  | { reachable: true; rtt: number }
  | { reachable: false; rtt: null };

export async function checkInternetConnectivity(): Promise<ConnectivityResult> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), PROBE_TIMEOUT_MS);
  const start = Date.now();
  try {
    await fetch(`${GOOGLE_PROBE_URL}?_=${start}`, {
      method: "HEAD",
      mode: "no-cors",
      cache: "no-store",
      signal: controller.signal,
    });
    const rtt = Date.now() - start;
    return { reachable: true, rtt };
  } catch {
    return { reachable: false, rtt: null };
  } finally {
    clearTimeout(timer);
  }
}
